'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var Modal = _interopDefault(require('react-modal'));
var PropTypes = _interopDefault(require('prop-types'));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ReactModal__Overlay--after-open {\n  display: flex;\n}\n\n.modal-window:focus {\n  outline: none !important;\n}\n\n.modal-window.body {\n  height: 100%;\n  padding: 16px;\n}\n.modal-window {\n  padding: 0;\n  width: 100%;\n}\n\n.my-modal {\n  display: block;\n}\n\n.modal-window.uk-container-xsmall {\n  width: 100%;\n  max-width: 750px !important;\n}\n\n\n.uk-modal-title {\n  margin-top: 0;\n}\n\n.close-button {\n  margin-top: 14px;\n}\n\n.modal-window.uk-container-small {\n  width: 100%;\n  max-width: 900px !important;\n}\n\n\n\n.modal-window.uk-container-large {\n  width: 100%;\n  max-width: 1600px !important;\n}\n\n\n.modal-window.uk-container-expand {\n  width: 100%;\n  max-width: none !important;\n}\n\n\n@media screen and (max-width: 640px) {\n  .modal-window {\n    padding: 0 8px;\n  }\n\n  .modal-window:focus {\n    outline: none !important;\n  }\n\n  .uk-modal {\n    -webkit-overflow-scrolling: auto !important;\n    padding: 0;\n  }\n\n}\n";
styleInject(css);

/**
 * Created by valentin on 20/07/2017.
 */
Modal.setAppElement('#root');

var ModalWindow = function ModalWindow(_ref) {
  var modalIsOpen = _ref.modalIsOpen,
      toggleModal = _ref.toggleModal,
      width = _ref.width,
      title = _ref.title,
      children = _ref.children,
      disableClosing = _ref.disableClosing,
      footer = _ref.footer;
  return React.createElement(Modal, {
    overlayClassName: 'uk-modal uk-open my-modal',
    isOpen: modalIsOpen,
    htmlOpenClassName: 'uk-modal-page',
    onRequestClose: disableClosing ? null : toggleModal,
    className: "uk-modal-dialog modal-window uk-container uk-container-".concat(width),
    contentLabel: "Example Modal"
  }, React.createElement("div", {
    className: "uk-modal-header header"
  }, disableClosing ? null : React.createElement("button", {
    className: "uk-float-right uk-icon uk-close close-button",
    type: "button",
    onClick: toggleModal
  }, React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.1",
    x1: "1",
    y1: "1",
    x2: "13",
    y2: "13"
  }), React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.1",
    x1: "13",
    y1: "1",
    x2: "1",
    y2: "13"
  }))), React.createElement("h2", {
    className: "uk-modal-title"
  }, title)), React.createElement("div", {
    className: "uk-modal-body body uk-overflow-auto",
    "data-uk-overflow-auto": "",
    style: {
      minHeight: '150px',
      maxHeight: '617px'
    }
  }, children), footer ? React.createElement("div", {
    className: "uk-modal-footer footer uk-text-right"
  }, footer) : null);
};

ModalWindow.propTypes = {
  title: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  footer: PropTypes.object,
  children: PropTypes.object.isRequired,
  width: PropTypes.oneOf(['xsmall', 'small', 'large', 'expand']),
  disableClosing: PropTypes.bool
};
ModalWindow.defaultProps = {
  disableClosing: false,
  width: 'small'
};

module.exports = ModalWindow;
